import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const EagleVizion = ({
  SINCE = "since 2006",
  TITLE = "Eagle Vizion",
  SPECIALISTS = "Specialists in",
  HYPERSPECTRAL = "Identification and Sorting",
  ABOUT_US = "About Us",
  ABOUT_DESC = "Canadian company founded in 2006, started with the following markets:",
  MRF = "MRF, Recyclers & C&D",
  PET_REMOVAL = "PET recycling, removal of PETG, PET with PVC sleeves etc.",
  DIVERSIFICATION = "2012 Diversification",
  DIVERSIFICATION_DESC = "Since 2012, EV diversified its product offerings:",
  CONVEYOR = "Conveyor Audit QC",
  SWIR = "NIR+AI bottle sorter QC",
  FLAKE_SORTERS = "Flake Sorter FSR up to 50/50 streams",
  FLAKE_ANALYZER = "Flake Analyzer",
}) => {
  const [, setIsVisible] = useState(false);
  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState({
    SINCE, TITLE, SPECIALISTS, HYPERSPECTRAL, ABOUT_US, ABOUT_DESC,
    MRF, PET_REMOVAL, DIVERSIFICATION, DIVERSIFICATION_DESC,
    CONVEYOR, SWIR, FLAKE_SORTERS, FLAKE_ANALYZER,
  });

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    const translateAll = async () => {
      const keys = [
        'SINCE', 'TITLE', 'SPECIALISTS', 'HYPERSPECTRAL', 'ABOUT_US', 'ABOUT_DESC',
        'MRF', 'PET_REMOVAL', 'DIVERSIFICATION', 'DIVERSIFICATION_DESC',
        'CONVEYOR', 'SWIR', 'FLAKE_SORTERS', 'FLAKE_ANALYZER',
      ];
      const originalTexts = {
        SINCE, TITLE, SPECIALISTS, HYPERSPECTRAL, ABOUT_US, ABOUT_DESC,
        MRF, PET_REMOVAL, DIVERSIFICATION, DIVERSIFICATION_DESC,
        CONVEYOR, SWIR, FLAKE_SORTERS, FLAKE_ANALYZER,
      };

      const newTranslations = {};

      const translationPromises = keys.map(async (key) => {
        const translated = await translateContent(originalTexts[key]);
        return { key, translated };
      });

      const results = await Promise.all(translationPromises);

      results.forEach(({ key, translated }) => {
        newTranslations[key] = translated;
      });

      setTranslations(newTranslations);
    };

    translateAll();
  }, [currentLanguage,
    SINCE, TITLE, SPECIALISTS, HYPERSPECTRAL, ABOUT_US, ABOUT_DESC,
    MRF, PET_REMOVAL, DIVERSIFICATION, DIVERSIFICATION_DESC,
    CONVEYOR, SWIR, FLAKE_SORTERS, FLAKE_ANALYZER,
    translateContent]);

  return (
    <section className="eagle-vizion-area pb-80">
      <div className="container">
        <div className="row align-items-center">
         <div className="col-xl-12">
  <div className="section__wrapper mb-55">
    <div className="row align-items-end">
      <div className="col-lg-8">
  <div className="r-text">
    <span>{translations.SINCE}</span>
  </div>
  <h4 className="section__title">
    <span className="section__title-line3">{translations.TITLE}</span>
    <span className="section__title-line2">{translations.SPECIALISTS}</span>
    <span className="section__title-line1">{translations.HYPERSPECTRAL}</span>
  </h4>
</div>

    </div>
  </div>
</div>

        </div>

        <div className="row align-items-center">
          <div className="col-xl-6 col-lg-6">
            <div className="eagle-content mb-40">
              {/* About Us Section */}
              <div className="eagle-section mb-40">
                <h5 className="eagle-section-title mb-20">{translations.ABOUT_US}</h5>
                <p className="eagle-description mb-25">
                  {translations.ABOUT_DESC}
                </p>
                <div className="eagle-list">
                  <div className="eagle-list-item mb-15">
                    <span>{translations.MRF}</span>
                  </div>
                  <div className="eagle-list-item">
                    <span>{translations.PET_REMOVAL}</span>
                  </div>
                </div>
              </div>

              {/* Diversification Section */}
              <div className="eagle-section">
                <h5 className="eagle-section-title mb-20">{translations.DIVERSIFICATION}</h5>
                <p className="eagle-description mb-25">
                  {translations.DIVERSIFICATION_DESC}
                </p>
                <div className="eagle-grid">
                  <div className="eagle-vizion-card">
                    <h6 className="eagle-card-title">{translations.CONVEYOR}</h6>
                  </div>
                  <div className="eagle-vizion-card">
                    <h6 className="eagle-card-title">{translations.SWIR}</h6>
                  </div>
                  <div className="eagle-vizion-card">
                    <h6 className="eagle-card-title">{translations.FLAKE_SORTERS}</h6>
                  </div>
                  <div className="eagle-vizion-card">
                    <h6 className="eagle-card-title">{translations.FLAKE_ANALYZER}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-6 col-lg-6">
            <div className="eagle-images mb-40">
              <div className="eagle-image-grid">
                <div className="eagle-image-container eagle-image-qc">
                  <img src="assets/img/products/QC/image000001.jpg" alt="AI QC Sorter" />
                </div>
                <div className="eagle-image-stack">
                  <div className="eagle-image-container eagle-image-half-v">
                    <img src="assets/img/about/about-1.png" alt="Sorting Equipment" />
                  </div>
                  <div className="eagle-image-container eagle-image-half-v">
                    <img src="assets/img/products/FA/P1500801.jpg" alt="Flake Analyzer" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* Eagle Vizion Styles */
        .eagle-vizion-area {
          padding: 80px 0;
          font-family: 'Inter', 'Poppins', 'Segoe UI', sans-serif;
          background: linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%);
          margin-bottom: 50px;
        }
        
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 15px;
        }
        
        .row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -15px;
        }
        
        .align-items-center {
          align-items: center;
        }
        
        .align-items-end {
          align-items: flex-end;
        }
        
        .col-xl-12, .col-xl-6, .col-lg-6, .col-lg-8, .col-lg-4 {
          position: relative;
          width: 100%;
          padding: 0 15px;
        }
        
        .col-xl-6, .col-lg-6 {
          flex: 0 0 50%;
          max-width: 50%;
        }
        
        .col-lg-8 {
          flex: 0 0 66.666667%;
          max-width: 66.666667%;
        }
        
        .col-lg-4 {
          flex: 0 0 33.333333%;
          max-width: 33.333333%;
        }
        
        .mb-40 {
          margin-bottom: 40px;
        }
        
        .mb-55 {
          margin-bottom: 55px;
        }
        
        .mb-30 {
          margin-bottom: 30px;
        }
        
        .mb-25 {
          margin-bottom: 25px;
        }
        
        .mb-20 {
          margin-bottom: 20px;
        }
        
        .mb-15 {
          margin-bottom: 15px;
        }
        
        .pb-80 {
          padding-bottom: 80px;
        }
        
        .text-lg-end {
          text-align: right;
        }
        
        /* Section title styles */
        .section__wrapper {
          margin-bottom: 55px;
        }
        
        .section__title {
          font-size: 2.5rem;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 0;
          display: flex;
          flex-direction: column;
        }
        
        .section__title-line1 {
          font-size: 1.8rem;
          font-weight: 600;
          color: #2b5baa;
          margin-bottom: 0.2rem;
        }
        
        .section__title-line2 {
          font-size: 2.2rem;
          font-weight: 600;
          color: #333;
          margin-bottom: 0.2rem;
        }
        
        .section__title-line3 {
          font-size: 2.2rem;
          font-weight: 600;
          color: #2b5baa;
        }
        
       .r-text {
  font-style: italic;
  color: #888;
  font-size: 1.2rem;
  position: relative;
  padding-bottom: 5px;
  margin-bottom: 8px; /* adds space before the title */
}

.r-text:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 90px;
  height: 2px;
  background: #2b5baa;
}

        
        /* Eagle specific styles */
        .eagle-section {
          padding: 25px;
          background-color: #f8fafc;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          margin-bottom: 30px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.04);
        }
        
        .eagle-section-title {
          font-size: 1.5rem;
          color: #2b5baa;
          font-weight: 600;
          padding-bottom: 10px;
          border-bottom: 2px solid #e2e8f0;
        }
        
        .eagle-description {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #4a5568;
        }
        
        .eagle-list {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }
        
        .eagle-list-item {
          padding: 15px 20px;
          background-color: white;
          border-radius: 8px;
          border-left: 4px solid #2b5baa;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
          font-weight: 500;
          color: #374151;
          transition: transform 0.2s ease;
        }
        
        .eagle-list-item:hover {
          transform: translateX(5px);
        }
        
        .eagle-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }
        
        .eagle-vizion-card {
          background-color: white;
          border-radius: 10px;
          padding: 20px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 80px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
          cursor: pointer;
        }
        
        .eagle-vizion-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(13, 59, 102, 0.15);
        }
        
        .eagle-card-title {
          font-size: 1rem;
          color: #2b5baa;
          margin: 0;
          font-weight: 600;
          line-height: 1.4;
        }
        
        .eagle-images {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .eagle-image-grid {
          display: flex;
          gap: 12px;
          height: 420px;
        }

        .eagle-image-qc {
          flex: 1;
          height: 100%;
        }

        .eagle-image-qc img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.5s ease;
        }

        .eagle-image-stack {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 12px;
          height: 100%;
        }

        .eagle-image-half-v {
          flex: 1;
          min-height: 0;
        }

        .eagle-image-half-v img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.5s ease;
        }
        
        .eagle-image-container {
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 8px 30px rgba(13, 59, 102, 0.14);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          background-color: #000;
          position: relative;
          flex-shrink: 0;
        }
        
        .eagle-image-container:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 50px rgba(13, 59, 102, 0.25);
        }

        /* legacy fallback */
        .eagle-image-large img,
        .eagle-image-half img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          display: block;
          transition: transform 0.5s ease;
        }
        
        .eagle-image-container:hover img {
          transform: scale(1.07);
        }
        
        .image-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(transparent 0%, rgba(10, 30, 70, 0.82) 100%);
          padding: 28px 20px 18px;
          opacity: 0;
          transform: translateY(8px);
          transition: all 0.35s ease;
        }
        
        .eagle-image-container:hover .image-overlay {
          opacity: 1;
          transform: translateY(0);
        }
        
        .image-title {
          color: white;
          font-size: 1rem;
          font-weight: 700;
          margin: 0 0 3px 0;
          letter-spacing: 0.3px;
        }

        .image-subtitle {
          color: rgba(255,255,255,0.75);
          font-size: 0.8rem;
          margin: 0;
          font-weight: 400;
          letter-spacing: 0.5px;
          text-transform: uppercase;
        }
        
        /* Responsive styles */
        @media (max-width: 992px) {
          .section__title {
            font-size: 2rem;
          }
          
          .section__title-line1 {
            font-size: 1.5rem;
          }
          
          .section__title-line2 {
            font-size: 1.8rem;
          }
          
          .section__title-line3 {
            font-size: 2.2rem;
          }
          
          .r-text {
            text-align: left !important;
            margin-top: 15px;
          }
          
          .col-xl-6, .col-lg-6 {
            flex: 0 0 100%;
            max-width: 100%;
          }
        }
        
        @media (max-width: 768px) {
          .eagle-grid {
            grid-template-columns: 1fr;
          }
          
          .col-lg-8, .col-lg-4 {
            flex: 0 0 100%;
            max-width: 100%;
          }
        }
      `}</style>
    </section>
  );
};

export default EagleVizion;